import { type Variants } from 'framer-motion';

export enum InputRadioCommonVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const fadeInVariants: Variants = {
    [InputRadioCommonVariant.Hidden]: {
        opacity: 0,
    },
    [InputRadioCommonVariant.Show]: {
        opacity: 1,
    },
};

// TODO: Only animating "downwards" for now,
// until we have time to better implement a `Tooltip`.
export const tooltipInteriorVariants: Variants = {
    [InputRadioCommonVariant.Hidden]: {
        // translateX: 22
        translateY: 0,
    },
    [InputRadioCommonVariant.Show]: {
        // translateX: 32
        translateY: 4,
    },
};
